import React from 'react'
import Icon from 'shared/ui/Icon'
import Heading from './Heading'

function ContentTile({ children, as: Comp = 'div', title, iconName, iconColor }) {
  return (
    <Comp className="spacing-small">
      {iconName && <Icon name={iconName} size={2} color={iconColor} />}
      <Heading as="h2" size={3}>
        {title}
      </Heading>
      <div className="spacing">{children}</div>
    </Comp>
  )
}

export default ContentTile
